import { ApolloClient } from "apollo-client";
import { createHttpLink } from "apollo-link-http";
import { InMemoryCache, NormalizedCacheObject } from "apollo-cache-inmemory";
import logger from "apollo-link-logger";
import { from, Operation } from "apollo-link";
import { onError } from "apollo-link-error";
import { setContext } from "apollo-link-context";
import RequestLink from "./requestLink";

import { GraphQLError } from "graphql";
import { store } from "store";
import { BASE_URL } from "shared/constants";

interface ConfigureApolloOptions {
  onGraphqlError?: (errors: ReadonlyArray<GraphQLError>) => boolean | void;
  onNetworkError?: (error: Error) => boolean | void;
  onRequestStart?: (operation: Operation) => void;
  onRequestEnd?: (operation: Operation) => void;
}
type ConfigureApollo = (
  options: ConfigureApolloOptions,
) => ApolloClient<NormalizedCacheObject>;

export const configureApollo: ConfigureApollo = ({
  onGraphqlError,
  onNetworkError,
  onRequestStart,
  onRequestEnd,
}) => {

  const http = createHttpLink({
    // uri: 'https://automemo-api.herokuapp.com/graphql/default',
    uri: `${BASE_URL}/graphql/default`,
  });

  const authLink = setContext((_, { headers }) => {
    const { token } = store.getState();
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : "",
      },
    };
  });

  const error = onError(({ response, graphQLErrors, networkError }) => {
    let prevent: boolean | void = false;
    if (networkError && networkError) {
      prevent = onNetworkError(networkError);
    } else if (graphQLErrors && onGraphqlError) {
      prevent = onGraphqlError(graphQLErrors);
    }
    if (prevent === undefined || prevent === true) {
      if (response){
      }
    }
  });
  const loading = new RequestLink({
    onStart: onRequestStart,
    onEnd: onRequestEnd,
  });

  const fullApolloLink = from([logger, loading, error, authLink, http]);

  return new ApolloClient({
    link: fullApolloLink,
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: "network-only",
        errorPolicy: "ignore",
      },
      query: {
        fetchPolicy: "network-only",
        errorPolicy: "all",
      },
    }
  });
};



// WEBPACK FOOTER //
// ./src/api/client.ts